$(document).ready(function() {
//1月
$('#jan .mainImg figure, .month01 figure').addClass('sdot');
//2月
$('#feb .mainImg figure, .month02 figure').addClass('sdot');
//3月
$('#mar .mainImg figure, .month03 figure').addClass('sdot');
//4月
$('#apr .mainImg figure, .month04 figure').addClass('sdot');
//5月
$('#may .mainImg figure, .month05 figure').addClass('sdot');
//6月
$('#jun .mainImg figure, .month06 figure').addClass('sdot');
//7月
$('#jul .mainImg figure, .month07 figure').addClass('sdot');
//8月
$('#aug .mainImg figure, .month08 figure').addClass('sdot');
//9月
$('#sep .mainImg figure, .month09 figure').addClass('sdot');
//10月
$('#oct .mainImg figure, .month10 figure').addClass('sdot');
//11月
$('#nov .mainImg figure, .month11 figure').addClass('sdot');
//12月
$('#dec .mainImg figure, .month12 figure').addClass('sdot');
});
